module.exports = __webpack_public_path__ + "dash_20_app_assets/img/embed.620d8679.png";